import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import SquareCardList from 'ugc/components/ugcGallery/square/SquareCardList';
import { gameTypes } from 'config/promoGameTypes';

export default function SquareContainer({
    config,
    clientBodyRef,
    data,
    buttonLink,
    isInit = true,
    setIsInit = () => {}
}) {
    const { type: promoType, promoIdOfUgcLink: promoId } = useSelector(s => s.promo);
    const igGame = promoType === gameTypes.INSTAGRAM;
    const collections = () => data;

    return (
        <>
            <div ref={clientBodyRef} css={containerStyle(isInit)}>
                <SquareCardList
                    config={config}
                    data={collections}
                    buttonLink={buttonLink}
                    disableLink={false}
                    igGame={igGame}
                    isInit={isInit}
                    setIsInit={setIsInit}
                    promoId={promoId}
                />
            </div>
        </>
    );
}

const containerStyle = isInit => css`
    overflow: hidden;
    position: relative;
    min-height: 400px;
    display: flex;
    justify-content: center;
    max-height: 880px;
    padding: 16px 0 0 0;
    ${!isInit && `opacity:0;`}
`;
